import { render } from "./DisplayPage.vue?vue&type=template&id=88b40638&scoped=true"
import script from "./DisplayPage.vue?vue&type=script&lang=js"
export * from "./DisplayPage.vue?vue&type=script&lang=js"

import "./DisplayPage.vue?vue&type=style&index=0&id=88b40638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b40638"]])

export default __exports__